import { UnitSystem } from '@ravago/shared/page-data/models/config';

export class PhysicalPropertiesUtils {
   public static getNumberFromCondition = (unit: UnitSystem, condition: string | null): number => {
      const measurement = unit === 'SI' ? 'mm' : 'in';
      return parseFloat(condition?.replace(` ${measurement}`, '') ?? '0') ?? 0;
   };
}
